import { getPropCacheMixin } from "../utils/cache.js";
export var ariaHidden = {
  'aria-hidden': 'true'
};
export default getPropCacheMixin('$attrs', 'qAttrs');